import React from 'react';
import './App.css';
import Login from "./pages/Login/Login";
import Landing from "./pages/Landing/Landing";
import Registration from "./pages/Registration/Registration";
import UserProfile from "./pages/Dashboard/Dashboard";
import Medications from "./pages/Medications/Medications";
import Library from "./pages/Library/Library";
import Appointments from "./pages/Appointments/Appointments";
import Settings from "./pages/Settings/Settings";
import Help from "./pages/HelpSupport/Help";
import AboutUs from "./pages/AboutUs/AboutUs";
import MedicalHistory from "./pages/MedicalHistory/MedicalHistory";
import Result from "./pages/Results/Results";
import CareTeam from "./pages/CareTeam/CareTeam";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Notes from './pages/Notes/Notes';
import Results from './pages/Results/Results';
import CategoryView from './components/Results/CategoryView';
import Callback from './pages/Callback/Callback';
import WelbyFloatingChat from "./pages/Landing/WelbyFloatingChat";
import "./pages/Landing/WelbyFloatingChat.css";
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import './pages/PrivacyPolicy/PrivacyPolicy.css';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  const location = useLocation();
  const isLanding = location.pathname === "/";

  return (
    <div>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/dashboard" element={<UserProfile />} />
        <Route path="/medications" element={<Medications />} />
        <Route path="/library" element={<Library />} />
        <Route path="/appointments" element={<Appointments/>}/>
        <Route path="/settings" element={<Settings/>}/>
        <Route path="/help" element={<Help/>}/>
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/medicalhistory" element={<MedicalHistory/>}/>
        <Route path="/results" element={<Result/>}/>
        <Route path="/careteam" element={<CareTeam/>}/>
        <Route path="/notes" element={<Notes/>}/>
        <Route path="/results" element={<Results/>}/>
        <Route path="/files/:category" element={<CategoryView />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      {!isLanding && <WelbyFloatingChat />}
    </div>
  );
}

function AppWrapper() {
  return (
    <LanguageProvider>
      <Router>
        <App />
      </Router>
    </LanguageProvider>
  );
}

export default AppWrapper;